import React, { useRef, useEffect } from 'react';

const ResponsiveTitle = ({ text, style, className }) => {
    const textRef = useRef(null);

    useEffect(() => {
        const adjustFontSize = () => {
            if (!textRef.current) return;

            const container = textRef.current.parentNode;
            let initialFontSize = Math.min(container.clientWidth / 14, 24);
            textRef.current.style.fontSize = `${initialFontSize}px`;
        };

        adjustFontSize();
        window.addEventListener('resize', adjustFontSize);

        return () => {
            window.removeEventListener('resize', adjustFontSize);
        };
    }, [text]); // React on text changes

    return <p ref={textRef} style={style} className={className}>{text}</p>;
};

export { ResponsiveTitle };
